export default __webpack_public_path__ + "static/media/mlc-tamplarie.12088833.jpeg";